import React from 'react';
import { ChatRound } from '@solar-icons/react';
import { useTranslation } from 'react-i18next';

const LegacyVaultTestimonial: React.FC = () => {
    const { t } = useTranslation();
    return (
        <section className="overflow-x-hidden py-12 lg:py-16">
            <div className="relative mx-auto max-w-[1142px] px-4">
                <div className="mx-auto max-w-4xl text-center">
                    <div className="relative rounded-2xl border border-green-200 bg-white p-8 lg:p-12 dark:border-green-800 dark:bg-dark">
                        <div className="mb-6 flex justify-center">
                            <ChatRound size={32} color="#2a6355" />
                        </div>

                        <blockquote className="mb-8 text-lg italic text-gray-700 dark:text-gray-300 lg:text-xl">
                            {t('lv_page.testimonial.text')}
                        </blockquote>

                        <div className="flex flex-col items-center gap-2">
                            <cite className="not-italic font-semibold text-green-700 dark:text-white">{t('lv_page.testimonial.cite')}</cite>
                            <div className="flex gap-1">
                                {[...Array(5)].map((_, i) => (
                                    <span key={i} className="text-yellow-400">
                                        ★
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LegacyVaultTestimonial;
